<template>
  <div>

    <div class="container-xl">
      <div class="row archives">
        <h3 class="archives1">编辑个人档案</h3>
        <div class="archives2">
          <el-upload
            class="avatar-uploader"
            :headers="myHeaders"
            action="https://mybeame.com/user/uploadUserIcon"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
          >
            <img v-if="imageUrl" :src="imageUrl" class="avatar" />
            <i v-else class="">
              <img
                style="width: 80px; height: 80px"
                src="../img/Frame33.png"
                alt=""
            /></i>
          </el-upload>
        </div>
        <div class="data">
          <van-field
            v-model="userName"
            label="姓名"
            placeholder="请输入用户名"
            maxlength="40"
          />
          <van-field
            v-model="userPhone"
            type="tel"
            label="手机号"
            placeholder="请输入手机号"
            maxlength="20"
          />
          <van-field
            v-model="mail"
            label="邮箱"
            placeholder="请输入邮箱"
            maxlength="30"
          />
          <van-field
            v-model="address"
            rows="1"
            autosize
            label="地址"
            type="textarea"
            maxlength="50"
            show-word-limit
            placeholder="请输入个人住址"
          />
        </div>
        <div>
          <button @click="sign" class="Submit">提交</button>
        </div>

        <div>
          <router-link to="/personal"
            ><button class="giveup">放弃编辑</button></router-link
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { updateMyInfo } from "@/api/outpatient";
import { getUser } from "@/api/outpatient";
export default {

  metaInfo:{
    link:[{
      rel:'canonical',
      href:'https://mybeame.com/edit'
    },{
      rel:'alternate',
      href:'https://mybeame.com/edit',
      hrefLang:'x-default'
    }
    ]
  },

  data() {
    return {
      imageUrl: "",
      userName: "",
      userPhone: "",
      mail: "",
      address: "",
      uresData: {},
      myHeaders: {},
    };
  },
  mounted() {
    //获取本地储存数据
    var data = JSON.parse(localStorage.getItem("data"));
    this.myHeaders.token = data.token;

    //获取个人信息
    getUser().then((res) => {
      if (res.data.icon != "") {
        this.imageUrl = res.data.icon;
      }
      this.userName = res.data.userName;
      this.userPhone = res.data.phone;
      this.mail = res.data.mail;
      this.address = res.data.address;
    });
  },

  methods: {
    //上传图片
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      // const isJPG = file.type === "image/jpeg/PNG";
      const isLt2M = file.size / 1024 / 1024 < 2;
      // if (!isJPG) {
      //   this.$message.error("上傳頭像圖片只能是JPG格式！");
      // }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过2MB");
      }
      return isLt2M;
    },

    //提交个人信息事件
    sign() {
      this.subData = Object.assign(this.uresData);
      var uresData = {
        userName: this.userName,
        phone: this.userPhone,
        mail: this.mail,
        address: this.address,
      };
      //修改个人信息请求
      updateMyInfo(uresData).then((res) => {
        if (res.code == 200) {
          this.$router.push("/personal");
        }
      });
    },
  },
};
</script>
<style scoped>
.container-xl {
  padding: 100px 0 150px 0;
  background-color: #f2f2f2;
}
.row {
  margin-left: 0;
  margin-right: 0;
}
.archives {
  width: 60%;
  margin: auto;
  text-align: center;
  border-radius: 0px 100px 0px 0px;
  background-color: #ffffff;
}
.archives > h3 {
  font-size: 28px;
  margin-top: 50px;
  margin-bottom: 15px;
}
.avatar{
    width: 100px;
    height: 100px;
    display: block;
    border-radius: 50%;
}
.data {
  text-align: center;
}
.van-cell {
  width: 50%;
  margin: auto;
  border-radius: 10px;
  margin-bottom: 25px;
  margin-top: 25px;
  border: 2px solid #00e467;
}
.giveup {
  width: 50%;
  height: 44px;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 50px;
  background-color: #ffffff;
  border: 3px solid #00e467;
  border-radius: 0px 10px 0px 0px;
}
.Submit {
  width: 50%;
  height: 44px;
  margin: 20px 0;
  border: none;
  font-size: 16px;
  font-weight: 600;
  background: linear-gradient(90deg, #36ff94 0%, #00e467 100%);
  border-radius: 0px 10px 0px 0px;
}

h1,
h2,
h3,
h4,
h5,
button,
a {
  font-family: "chinaGenSenMaruGothicTW-Bold";
}

p,
span,
div {
  font-family: "chinaGenSenMaruGothicTW-Regular";
}

@media all and (max-width: 992px) {
  .container-xl {
    padding: 0;
    background-color: #ffffff;
  }
  .archives {
    width: 100%;
    border-radius: none;
  }
  .van-cell {
    width: 60%;
  }
  .Submit {
    width: 60%;
  }
  .giveup {
    width: 60%;
  }
}
@media all and (max-width: 570px) {
  .container-xl {
    padding: 0;
    background-color: #ffffff;
  }
  .archives {
    width: 100%;
    border-radius: none;
  }
  .van-cell {
    width: 90%;
  }
  .Submit {
    width: 90%;
  }
  .giveup {
    width: 90%;
  }
}
</style>